// Copyright (c) 2017 Deere & Company

import DealerInvoices from './components';
import Facets from './state/facets';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.dealerInvoices,
    allClaimsCount: state.claims.allClaims.allClaims.length,
    claimSearchCount: state.claims.claimSearch.searchResults.length,
    facets: new Facets({
        ...state.claims.dealerInvoices.facets,
        dealerAccountsFacet: {
            ...state.claims.dealerInvoices.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerInvoices);



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/state-connector.js